module.exports = {
      id: "snapchat-usage",
      viewBox: "0 0 64 60",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#snapchat",
      toString: function () {
        return this.url;
      }
    }